import { Directive, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { ResizedEvent } from './resized.event';
import { debounceTime, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[resized]',
  standalone: false
})
export class ResizedDirective implements OnInit, OnDestroy {
  private readonly observer: ResizeObserver;
  private oldRect?: DOMRectReadOnly;
  private readonly resizeSubject = new Subject<ResizeObserverEntry[]>();
  private readonly destroy$ = new Subject<void>();

  @Output() readonly resized;

  public constructor(
    private readonly _element: ElementRef,
    private readonly _zone: NgZone
  ) {
    this.resized = new EventEmitter<ResizedEvent>();
    this.observer = new ResizeObserver(entries => this._zone.run(() => this.resizeSubject.next(entries)));
  }

  ngOnInit(): void {
    this.observer.observe(this._element.nativeElement);

    this.resizeSubject
      .pipe(
        debounceTime(50), // Wait for 50ms of inactivity
        takeUntil(this.destroy$)
      )
      .subscribe(entries => {
        const domSize = entries[0];
        const resizedEvent = new ResizedEvent(domSize.contentRect, this.oldRect);
        this.oldRect = domSize.contentRect;
        this.resized.emit(resizedEvent);
      });
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
